<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.UnorderedList> = $props();

	const isTwoCols = $derived(data.items.length > 6);
</script>

<div class="max-w-screen-md w-full mb-6">
	<ul class={["custom-list columns-1", isTwoCols && "md:columns-2 md:gap-x-16"]}>
		{#each data.items as { id, text } (id)}
			<li class="break-inside-avoid md:text-[1.25rem]">
				<Formatted {text} />
			</li>
		{/each}
	</ul>
</div>
